import { useId } from "react";

// Instagram ve WhatsApp'ın renkli logoları (sosyal medya bağlantıları için)
export function InstagramLogo({ className = "w-7 h-7" }) {
  const id = `ig-${useId().replace(/:/g, "")}`;
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <defs>
        <radialGradient id={id} cx="0.3" cy="1.07" r="1.3">
          <stop offset="0" stopColor="#FFD776" />
          <stop offset="0.18" stopColor="#F3A554" />
          <stop offset="0.42" stopColor="#E1306C" />
          <stop offset="0.7" stopColor="#C13584" />
          <stop offset="1" stopColor="#5B51D8" />
        </radialGradient>
      </defs>
      <rect width="48" height="48" rx="12" fill={`url(#${id})`} />
      <rect x="10" y="10" width="28" height="28" rx="8.5" fill="none" stroke="#fff" strokeWidth="3.2" />
      <circle cx="24" cy="24" r="6.6" fill="none" stroke="#fff" strokeWidth="3.2" />
      <circle cx="32.2" cy="15.8" r="2" fill="#fff" />
    </svg>
  );
}

const WA_BUBBLE =
  "M24 10.5c-7.5 0-13.5 6-13.5 13.4 0 2.5.7 4.9 2 7L10.6 37.5l6.8-1.8c2 1.1 4.3 1.7 6.6 1.7 7.5 0 13.5-6 13.5-13.5S31.5 10.5 24 10.5z";
const WA_PHONE =
  "M19.4 17.6c-.3-.7-.6-.7-.9-.7h-.8c-.3 0-.7.1-1.1.5-.4.4-1.4 1.4-1.4 3.4s1.5 3.9 1.7 4.2c.2.3 2.9 4.6 7.1 6.3 3.5 1.4 4.2 1.1 5 1 .8-.1 2.5-1 2.8-2 .3-1 .3-1.8.2-2-.1-.2-.4-.3-.8-.5s-2.5-1.2-2.8-1.4c-.4-.1-.6-.2-.9.2-.3.4-1.1 1.4-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.8-.7-3.4-2.1-1.2-1.1-2.1-2.5-2.3-2.9-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.4-.7.1-.3.1-.5 0-.7-.1-.2-.9-2.3-1.4-3.2z";

// Yeşil daire içinde WhatsApp logosu
export function WhatsAppLogo({ className = "w-7 h-7" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <circle cx="24" cy="24" r="24" fill="#25D366" />
      <path d={WA_BUBBLE} fill="none" stroke="#fff" strokeWidth="2.6" strokeLinejoin="round" />
      <path d={WA_PHONE} fill="#fff" />
    </svg>
  );
}

// Yalnızca beyaz WhatsApp sembolü (yeşil zeminli butonlar için)
export function WhatsAppGlyph({ className = "w-7 h-7" }) {
  return (
    <svg viewBox="8 8 32 32" className={className} aria-hidden="true">
      <path d={WA_BUBBLE} fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinejoin="round" />
      <path d={WA_PHONE} fill="currentColor" />
    </svg>
  );
}
